module.exports = __webpack_public_path__ + "static/media/human-advantage-thumbsup.fd191bb8.svg";